<template>
  <div>
    <page-content-toolbar
      :title="$t('sidenav.profile')"
      :hide-project-name="true"
    >
    </page-content-toolbar>
    <v-form ref="form" v-model="valid" lazy-validation :disabled="loading" @submit="saveSettings" onsubmit="return false;">
      <v-card class="elevation-0">
        <!-- <v-card-title>{{ $t('profile.language') }}</v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <locale-changer class="float-left"/>
            </v-col>
          </v-row>
        </v-container> -->
        <v-card-title>{{ $t('profile.developmentMode') }}</v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="settings.mode"
                :items="availableModes"
                outlined
                hide-details
                :label="$t('profile.mode')"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            :loading="loading"
            :disabled="!valid"
            type="submit"
            class="raison-btn"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            {{ $t('global.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar'
// import LocaleChanger from '@/components/global/LocaleChanger'

import userService from '@/services/users.js';

export default {
  name: 'Profile',

  components: {
    // LocaleChanger,
    PageContentToolbar
  },

  mixins: [ ],

  data () {
    return {
      loading: false,
      modes: ['basic', 'advanced'],
      settings: {
        locale: 'en',
        mode: 'basic'
      },
      valid: false
    };
  },

  computed: {
    availableModes () {
      return this.modes.map(mode => { return { text: this.$t('profile.' + mode), value: mode } } )
    }
  },

  methods: {
    saveSettings (event) {
      event.preventDefault()
      this.loading = true
      console.log('saveSettings', this.settings)
      userService.saveSettings(this.settings)
        .then(() => {
          userService.setMode(this.$store, this.settings.mode)
          this.$emit('raison-event', { "type": "success", "messages": [ this.$t('profile.settingsSaved')]})
        })
        .catch((error) => {
          console.log('saveSettings error', error)
          this.$emit('raison-event', { "type": "error", "messages": [ this.$t('profile.settingsNotSaved')]})
        })
        .finally(() => {
          this.loading = false
        })
    }
  },

  created () {
    this.loading = true
    userService.getUserInfo()
      .then(response => {
        this.settings = response.data.settings
      })
      .catch((error) => {
        console.log('Profile.created error', error)
        this.$emit('raison-event', { "type": "error", "messages": [ this.$t('profile.settingsNotLoaded')]})
      })
      .finally(() => {
        this.loading = false
      })
  },
};
</script>

<style scoped>
</style>
